import React, { ChangeEvent } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import { Checkbox, Progress, TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { InventorySchemaActions } from '@atom/types/actions';
import iconUtilities from '@atom/utilities/iconUtilities';

import classes from './elements.module.css';

const RIGHT_ARROW = 'right-arrow';
const DOWN_ARROW = 'down-arrow';
const VISIBLE = 'inherit';
const HIDDEN = 'none';

interface Element {
  id: string;
  name: string;
  elementGroups: any[];
  hasChildren: boolean;
  assetType: string;
  markerId?: number;
}

interface Props {
  element: Element;
  isChecked?: boolean;
  onClick: (id: string) => void;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    id: string,
    value: any,
  ) => void;
  value?: number;
  inventorySchemaActions: InventorySchemaActions;
  schemaQuantities: object;
  selectedItems: object;
  elementPath?: any[];
  loading?: boolean;
  parentId?: string;
}

const styles = {
  rowStyle: {
    paddingLeft: '25px',
  },
  imageStyle: {
    marginRight: '10px',
  },
  inputStyle: {
    textAlign: 'center',
  },
  fhwaStyle: {
    color: colors.neutral.gray,
    marginRight: '10px',
  },
};

class SchemaElementListRow extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      icon: iconUtilities.leftIcon(RIGHT_ARROW),
      expanded: HIDDEN,
    };
  }

  retrieveTreeNode = () => {
    const { element, elementPath, inventorySchemaActions } = this.props;

    if (!element.elementGroups) {
      const data = {
        id: R.last(element.id.split('.')),
        elementPath,
      };

      return inventorySchemaActions.retrieveInventorySchemaTreeNode(data);
    }
    return false;
  };

  toggleSection = () => {
    // @ts-ignore
    const { expanded } = this.state;

    if (expanded === HIDDEN) {
      this.setState({
        icon: iconUtilities.leftIcon(DOWN_ARROW),
        expanded: VISIBLE,
      });
      this.retrieveTreeNode();
    } else {
      this.setState({
        icon: iconUtilities.leftIcon(RIGHT_ARROW),
        expanded: HIDDEN,
      });
    }
  };

  render() {
    const {
      element,
      onClick,
      isChecked,
      onChange,
      value,
      loading,
      inventorySchemaActions,
      elementPath,
      selectedItems,
      schemaQuantities,
      parentId,
    } = this.props;
    // @ts-ignore
    const { icon, expanded } = this.state;
    // @ts-ignore
    const isDisabled = parentId && !selectedItems.has(parentId);

    const leftIcon = iconUtilities.buildElementIcon(
      element.markerId,
      styles,
      false,
    );

    return (
      <div style={styles.rowStyle}>
        <div
          className={clsx(
            classes.elementListRow,
            isDisabled && classes.disabled,
            classes.modal,
          )}
        >
          {element.hasChildren && (
            <span
              className={classes.schemaElementIcon}
              onClick={this.toggleSection}
            >
              {loading ? <Progress thickness={2} size={16} /> : icon}
            </span>
          )}
          <div>
            <Checkbox
              checked={isChecked}
              onChange={() => onClick(element.id)}
              disabled={isDisabled}
            />
          </div>
          <div
            className={classes.elementLabel}
            onClick={!isDisabled ? () => onClick(element.id) : () => {}}
          >
            {leftIcon}
            {element.name}
          </div>
          <div>
            <TextField
              name={element.id}
              type="number"
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                onChange(event, element.id, event.target.value)
              }
              value={value || 1}
              slotProps={{ input: { style: styles.inputStyle } }}
            />
          </div>
        </div>
        <div
          className={classes.subElementListContainer}
          style={{ display: expanded }}
        >
          {element.elementGroups &&
            element.elementGroups.map((elementGroup, elementGroupIndex) =>
              elementGroup.elements.map((subElement, subElementIndex) => {
                const subElementWithPathId = {
                  ...subElement,
                  id: `${element.id}.${subElement.id}`,
                };
                return (
                  <SchemaElementListRow
                    // @ts-ignore
                    isChecked={selectedItems.has(subElementWithPathId.id)}
                    schemaQuantities={schemaQuantities}
                    selectedItems={selectedItems}
                    onChange={onChange}
                    key={subElementWithPathId.id}
                    element={subElementWithPathId}
                    onClick={onClick}
                    loading={loading}
                    value={schemaQuantities[subElementWithPathId.id]}
                    inventorySchemaActions={inventorySchemaActions}
                    parentId={element.id}
                    elementPath={[
                      ...elementPath,
                      'elementGroups',
                      elementGroupIndex,
                      'elements',
                      subElementIndex,
                    ]}
                  />
                );
              }),
            )}
        </div>
      </div>
    );
  }
}

export default SchemaElementListRow;
